module.exports = __webpack_public_path__ + "img/tempo_logo.17ee6d29.svg";